import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.GetWhatsappNos();
  }

  WhatsappList:any[]=[];
  GetWhatsappNos()
  {
    let nos =  (<HTMLInputElement>document.getElementById("hdnWhatsapp")).value;
    this.WhatsappList = nos.split(",");
  }

}
